import { format, isValid, parseISO } from 'date-fns';

/**
 * Format a value that is a calendar date rather than a moment in time.
 *
 * Stripe reports a payout's arrival_date as a date — the API hands back
 * midnight UTC — so running it through `new Date(...)` and formatting in the
 * browser's zone lands on the previous evening, and the payout reads a day
 * early for anyone west of Greenwich. A payout that arrived on July 31 showed
 * as July 30 in Eastern time, which made the newest payout look missing.
 *
 * Take the date part and format that, so the day shown is the day the bank
 * reported no matter where the browser is.
 */
export const formatCalendarDate = (
    value?: string | null,
    pattern = 'MMM d, yyyy'
): string => {
    if (!value) return '';
    const [datePart] = value.split('T');
    // A date-only string parses as local midnight, so there is no offset left
    // to shift the day.
    const parsed = parseISO(datePart);
    return isValid(parsed) ? format(parsed, pattern) : value;
};
